<template>
  <v-dialog v-model="dialog" width="620px">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title class="text-uppercase">SỬA KỲ {{ titleType }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text class="my-6">
        <v-form ref="form" flat v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="6" class="style1">
              <v-autocomplete
                v-model="period"
                clear-icon="mdi-close"
                :items="sortPeriods"
                item-text="title"
                item-value="id"
                v-bind:label="`Kỳ ${titleType}`"
                placeholder="Tháng --/----"
                clearable
                outlined
                dense
                return-object
                :rules="[rules.required, isPeriod]"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" v-if="groupHeadFee.scope === 'group'" class="style">
              <v-divider v-if="inputToggle"></v-divider>
              <v-radio-group v-if="inputToggle" v-model="type" class="small-radio" row :rules="[rules.required]">
                <v-radio label="Giảm trừ theo mức phí cụ thể" value="fixed"></v-radio>
                <v-radio label="Giảm trừ theo phần trăm khoản phí" value="percentage"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="6" v-if="groupHeadFee.scope === 'group'">
              <v-text-field
                :value="priceValue"
                @input="handlePrice"
                v-bind:label="changeTextInput"
                v-bind:placeholder="changeTextInput"
                clearable
                outlined
                dense
                return-object
                :rules="[rules.required, rules.isNumber, regexTestPercentage]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" class="style">
              <v-divider />
              <v-textarea
                outlined
                full-width
                label="Ghi chú"
                placeholder="Nhập ghi chú cho kỳ này"
                v-model="notes"
                dense
                class="mt-6"
                hide-details
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-5">
        <v-btn depressed outlined color="grey darken-1" class="px-6 ml-4 mt-n4 mb-2 white--text" @click="cancel"
          >Hủy</v-btn
        >
        <v-spacer />
        <v-btn depressed color="primary" class=" px-6 mr-4 mt-n4 mb-2  white--text" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { inputRules } from '@/plugins/rule'
import { sortPeriod, getPriceInputPlaceholder } from '../utils'

export default {
  props: {
    state: Boolean,
    groupHeadFee: Object,
    prices: Array
  },
  data() {
    return {
      dialog: false,
      loading: false,
      priceValue: '',
      period: '',
      type: '',
      rules: inputRules,
      valid: true,
      checkPeriod: true,
      notes: ''
    }
  },
  computed: {
    titleType() {
      if (this.router === 'main') return 'chi'
      return this.$route.meta.title.replace('Chi tiết', '')
    },
    ...mapState('salaryPrice', ['price']),
    ...mapState('salaryHead', ['headFee', 'router', 'isSubFee']),
    ...mapState('salaryPeriod', ['periods']),
    changeTextInput() {
      return getPriceInputPlaceholder(this.router, this.isSubFee, this.type)
    },
    sortPeriods() {
      return sortPeriod(this.periods)
    },
    inputToggle() {
      return this.groupHeadFee.scope === 'group' && this.router === 'priority'
    }
  },
  methods: {
    ...mapActions('salaryHead', ['updatePriceGroupHeadFee']),
    ...mapActions('salaryPeriod', ['fetchPeriods']),

    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    },
    validate() {
      return this.$refs.form.validate()
    },
    handlePrice(value) {
      if (value) {
        let number = value.split(/\s*,\s*/).join('')
        this.priceValue = (+number).toLocaleString('en-US')
      }
    },
    regexTestPercentage(number) {
      return !(this.type === 'percentage' && +number > 100) || !number || 'Phần trăm tối đa 100%'
    },
    isPeriod(period) {
      if (!period) return true
      if (!this.prices.find(price => price.period.title === period.title)) return true
      if (this.router === 'main') return 'Kỳ chi này đã tồn tại'
      if (this.router === 'adjust') return 'Kỳ điều chỉnh này đã tồn tại'
      if (this.isSubFee) return 'Kỳ hoàn trả này đã tồn tại'
      return 'Kỳ truy thu này đã tồn tại'
    },
    async save() {
      if (this.validate()) {
        try {
          let payload = {
            id: this.price.id,
            price: {
              price: this.priceValue.split(/\s*,\s*/).join(''),
              type: this.type,
              period: typeof this.period === 'string' ? this.period : this.period.id,
              notes: this.notes
            },
            groupHeadFee: this.groupHeadFee
          }
          await this.updatePriceGroupHeadFee(payload)
          this.$alert.updateSuccess(`kỳ ${this.titleType}`)
          this.$refs.form.reset()
          this.dialog = false
        } catch (error) {
          this.$alert.updateError({
            title: 'Lỗi thao tác',
            description: `Không thể chỉnh sửa kỳ ${this.titleType}. Vui lòng thử lại`
          })
          this.$refs.form.reset()
          this.dialog = false
        }
      }
    }
  },
  watch: {
    state() {
      this.dialog = true
    },
    price() {
      this.priceValue = this.price.price.toLocaleString('en-US')
      this.period = this.price.period.id
      this.type = this.price.type
      this.notes = this.price.notes
    }
  }
}
</script>
<style lang="scss" scoped>
.data-picker,
.text-field {
  width: 280px;
}
.style {
  margin-bottom: -15px !important;
}
.style1 {
  margin-bottom: -19px !important;
}
</style>
